const { REACT_APP_CONTEXT_PATH } = process.env;

export const chatbotApi = () => {
  return {
    apiUrl: REACT_APP_CONTEXT_PATH + `/chatbot/message/direct`,
  };
};
